export default class CodigoConfirmacao {
  constructor () {
    this.codigoVerificador = null
    this.identificacaoFiscal = null
  }
}
